import { api } from "@/config/api";
import type { AxiosError } from "axios";

import { ReceiptFailReason } from "ipctg-inflow-types/InFlowEnums";
import type { ParkReceiptPOSTErrorResponse, ParkReceiptPOSTRequest, ParkReceiptPOSTSuccessResponse } from "ipctg-inflow-types/InFlowParkAPI";

export const fetchReceiptData = async (requestData: ParkReceiptPOSTRequest): Promise<ParkReceiptPOSTSuccessResponse> => {
  try {
    const response = await api.post<ParkReceiptPOSTSuccessResponse>("/receipt", requestData);
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError<ParkReceiptPOSTErrorResponse>;
    throw axiosError.response?.data ?? { failReason: ReceiptFailReason };
  }
};
